import React from 'react';
import { WeatherPage as Weather } from 'components/Weather';

const WeatherPage = () => {
  return <Weather />;
};

export default WeatherPage;
